module.exports = __webpack_public_path__ + "static/media/ee.8de0b8af.png";